export default "__VITE_ASSET__CkWzLMDg__"